var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flex)?_c('div',{staticClass:"tree-column",class:{border: _vm.border!== undefined},style:({ width: _vm.width + 'px', flex: _vm.flex})},[_vm._t("default")],2):_c('div',{staticClass:"tree-column",class:{border: _vm.border!== undefined},style:({ width: _vm.width + 'px'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }